// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YG1q","question":"styles_question__1l7HT","description":"styles_description__3d-8X"};